/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'update';
const componentName = 'precheck-wizard-page';
const prefix = `${moduleName}.${componentName}`;

export const patchLabel = `${prefix}.patchLabel`;
export const rollbackLabel = `${prefix}.rollbackLabel`;
export const rollbackPatchLabel = `${prefix}.rollbackPatchLabel`;
export const headerLabel = `${prefix}.headerLabel`;
export const nodeNameLabel = `${prefix}.nodeNameLabel`;
export const transcriptLabel = `${prefix}.transcriptLabel`;
export const preCheckProgressLabel = `${prefix}.preCheckProgressLabel`;
export const preCheckPendingLabel = `${prefix}.preCheckPendingLabel`;
export const preCheckSuccessStatusLabel = `${prefix}.preCheckSuccessStatusLabel`;
export const preCheckErrorStatusLabel = `${prefix}.preCheckErrorStatusLabel`;
export const preCheckWarningStatusLabel = `${prefix}.preCheckWarningStatusLabel`;
export const preCheckInProgressStatusLabel = `${prefix}.preCheckInProgressStatusLabel`;
export const progressMessage = `${prefix}.progressMessage`;
export const preCheckSuccessMessage = `${prefix}.preCheckSuccessMessage`;
export const preCheckFailureMessage = `${prefix}.preCheckFailureMessage`;
export const preCheckWarningMessage = `${prefix}.preCheckWarningMessage`;
export const goToReportLabel = `${prefix}.goToReportLabel`;

export const ENGLISH = {
    [patchLabel]: 'Patch',
    [rollbackLabel]: 'Upgrade (Rollback)',
    [rollbackPatchLabel]: 'Patch (Rollback)',
    [headerLabel]: '{0} Transcript',
    [nodeNameLabel]: 'Source',
    [transcriptLabel]: 'Transcript',
    [preCheckProgressLabel]: 'Precheck Progress',
    [preCheckPendingLabel]: 'Pending',
    [preCheckSuccessStatusLabel]: 'Success',
    [preCheckErrorStatusLabel]: 'Error',
    [preCheckWarningStatusLabel]: 'Warning',
    [preCheckInProgressStatusLabel]: 'In Progress',
    [progressMessage]: 'This may take a couple of minutes. You may close the wizard and continue working. To check on progress you can re-access from \'In progress\' tile or upon completion from \'Recent\' tiles on the right.',
    [preCheckSuccessMessage]: '{0} Pre-check completed successfully {1}',
    [preCheckFailureMessage]: 'Pre-check failed {0}',
    [preCheckWarningMessage]: 'Pre-check came back with warnings {0}. We recommend taking a backup before proceeding with Update operation.',
    [goToReportLabel]: 'Go to Report',
};
